<template>
  <div v-if="isLoading" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="Loading">Loading...
  </div>
  <div v-else>
    <div style="display: flex; justify-content: center">
      <Section illust_title="最新插画" :imageData="imageInfos_new"></Section>
    </div>

    <div style="display: flex; justify-content: center;">
      <paginater :count="count" :type="0" @pageChange="pageChange"></paginater>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue'
import Section from '@/components/Section copy.vue';
import paginater from '@/components/paginater.vue';

export default {
  name: 'New',
  data() {
    return {
      isLoading: true,
      fullscreenLoading: ref(true),
      imageInfos_new: [],
      count: 8,
    }
  },
  components: {
    Section,
    paginater,
  },
  async created() {
    try {
      await this.loadData(0);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      this.isLoading = false;
    }

  },
  methods: {
    async loadData(offset) {
      await this.$axios.get(" https://www.vilipix.com/api/v1/picture/public?limit=30&sort=new&offset=" + offset * 30).then(res => {
        this.imageInfos_new = res.data.data.rows;
        this.count = res.data.data.count;
      }).catch(error => {
        console.log(error);
      })
    },

    pageChange(offset) {
      this.loadData(offset);
      console.log(offset);
    }
  }
}
</script>